import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import auth from './modules/auth'
import file from './modules/file'
import region from './modules/region'
import proceso from './modules/process' // Se llama proceso porque process es palabra reservada
import currentProcess from './modules/currentProcess'
import song from './modules/example'

import vuexPersistedstate from 'vuex-persistedstate'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const persistedState = vuexPersistedstate({
  key: 'defor_app_state',
  reducer: state => ({
    auth: state.auth
  })
})

export default new Vuex.Store({
  modules: {
    app,
    auth,
    file,
    region,
    proceso,
    currentProcess,
    song
  },
  plugins: [persistedState],
  strict: debug
})
